<template>
  <el-container class="details container no-padding">
    <About :lesson="lesson"/><br>
    <div class="videos" v-for="(video, index) in lesson.videos" :key="index">
      <Video :video="video" :index="index + 1" @expanded="didExpand(index + 1)" :shouldCollapse="current !== (index + 1)" />
    </div>
    <Quiz @expanded="didExpand(3)" :shouldCollapse="current !== 3" :questions="lesson.quiz.questions" />
  </el-container>
</template>

<script>
// @ is an alias to /src
import About from "@/components/lessons/details/About"
import Video from "@/components/lessons/details/Video"
import Quiz from "@/components/lessons/details/Quiz"
import { mapGetters } from 'vuex'

export default {
  name: 'Details',
  data () {
    return {
      current: null,
    }
  },
  components: {
    About,
    Video,
    Quiz
  },
  computed: {
    ...mapGetters({
      lesson: 'modules/current',
      email : 'user/email',
      requestedId: 'modules/requestedId'
    })
  },
  methods: {
    didExpand (index) {
      this.current = index
    }
  },
  mounted () {
    if (!this.email ) {
      if (this.$route.query.id) {
        this.$store.commit('modules/SET_REQUESTED_ID', parseInt(this.$route.query.id))
      }
      this.$router.push({name: 'login'})
    } else if (!this.lesson) {
      this.$router.push({name: 'home'})
    } else {
      if (this.lesson && this.$route.query.id != this.lesson.id) {
        this.$store.commit('modules/SET_REQUESTED_ID', parseInt(this.$route.query.id))
        this.$router.push({name: 'home', query: { id: this.$route.query.id }})
      } else {
        this.$store.commit('modules/SET_REQUESTED_ID', null);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/styles';
  .details {
    max-width: 860px;
    margin: auto;
    .videos {
      margin-top: 20px;
    }
    .quiz {
      margin-top: 20px;
    }
  }
</style>
